// @ts-strict-ignore
import { Image } from '@components/gassan-ui'
import { Button } from '@components/old-rolex-ui'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { Heading } from './ui/Heading'
import { Text } from './ui/Text'

type Props = {
  variant: 'image-text' | 'text-image'
  displayPlaque?: boolean
  desktopImage: AssetsElement
  mobileImage: AssetsElement
  title: string
  preTitle?: string
  description: string
  buttonTitle?: string
  buttonUrl?: string
}

const CheckerboardItem: FC<Props> = ({
  variant,
  desktopImage,
  displayPlaque = false,
  mobileImage,
  title,
  description,
  buttonTitle,
  preTitle,
  buttonUrl,
}) => {
  const {
    i18n: { language },
  } = useTranslation()
  const plaqueSrc = language === 'nl' ? '/images/rolex-plaque.jpeg' : '/images/rolex-plaque-en.jpeg'
  const isTextImage = variant === 'text-image'

  return (
    <div
      className={cn(
        'mb-12 mt-[5%] grid grid-cols-1 items-center gap-y-5',
        'ml-[5%] mr-[5%] lg:mb-0',
        !isTextImage
          ? 'lg:mr-[initial] lg:grid-cols-[45%_50%]'
          : 'lg:ml-[initial] lg:grid-cols-[50%_45%]',
      )}
    >
      <div className={cn('row-[1]', isTextImage ? 'lg:col-start-2' : 'lg:col-start-1')}>
        <Image
          className="aspect-square"
          sources={[
            getKontentImage(mobileImage?.value[0]?.url, { width: 600 }),
            getKontentImage(desktopImage?.value[0]?.url, { width: 600 }),
            getKontentImage(desktopImage?.value[0]?.url, { width: 1000 }),
          ]}
          placeholderSrc={getKontentImage(mobileImage?.value[0]?.url, { width: 50 })}
          alt={mobileImage?.value[0]?.description}
        />
      </div>
      <div
        className={cn(
          'row-[2] ',
          'lg:row-[1] lg:px-[7vw]',
          isTextImage ? 'lg:col-start-1' : 'lg:col-start-2',
        )}
      >
        {displayPlaque && (
          <img
            src={plaqueSrc}
            alt="rolex plaque"
            style={{ maxWidth: '7rem', marginBottom: '1rem' }}
          />
        )}
        {preTitle && (
          <Heading variant="very-small-title" as="div" className="mb-5">
            {preTitle}
          </Heading>
        )}
        <Heading variant="medium" className="mb-3">
          {title}
        </Heading>
        <Text variant="regular" style={{ whiteSpace: 'pre-line' }}>
          {description}
        </Text>
        {buttonTitle && buttonUrl && (
          <div className="mt-4 md:mt-6">
            <a href={buttonUrl}>
              <Button variant="primary">{buttonTitle}</Button>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default CheckerboardItem
